/* eslint-disable no-underscore-dangle */
import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000'
});

api.interceptors.request.use(
  async (config) => {
    const user = sessionStorage.getItem('user');
    const keys = JSON.parse(user);
    if (keys) {
      config.headers = {
        Authorization: `Bearer ${keys.token}`
      };
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);
const shouldIntercept = (error) => {
  try {
    return error.response.status === 401;
  } catch (e) {
    return false;
  }
};

const setTokenData = (data = {}, axiosClient) => {
  sessionStorage.setItem('user', JSON.stringify(data));
  axiosClient.defaults.headers.common.Authorization = `Bearer ${data.token}`;
};

const handleTokenRefresh = () => {
  const user = sessionStorage.getItem('user');
  const keys = JSON.parse(user);

  return new Promise((resolve, reject) => {
    api.post('/auth/refresh', { refreshToken: keys.refreshToken })
      .then(({ data }) => {
        resolve(data);
      })
      .catch((err) => {
        reject(err);
      });
  });
};

const attachTokenToRequest = (request, token) => {
  request.headers.Authorization = `Bearer ${token}`;
};

let isRefreshing = false;
let failedQueue = [];

const options = {
  attachTokenToRequest,
  handleTokenRefresh,
  setTokenData,
  shouldIntercept,
};
const processQueue = (error, token = null) => {
  failedQueue.forEach((prom) => {
    if (error) {
      prom.reject(error);
    } else {
      prom.resolve(token);
    }
  });

  failedQueue = [];
};

const interceptor = (error) => {
  if (error.config.url === '/auth') {
    return Promise.reject(error);
  }

  if (!options.shouldIntercept(error)) {
    return Promise.reject(error);
  }

  if (error.config && error.config.url === '/auth/refresh') {
    sessionStorage.removeItem('user');
    return window.location.replace('/');
  }

  if (error.config._retry || error.config._queued) {
    return Promise.reject(error);
  }

  const originalRequest = error.config;
  if (isRefreshing) {
    return new Promise((resolve, reject) => {
      failedQueue.push({ resolve, reject });
    }).then((token) => {
      originalRequest._queued = true;
      options.attachTokenToRequest(originalRequest, token);
      return api.request(originalRequest);
    }).catch((err) => {
      Promise.reject(error);
    });
  }

  originalRequest._retry = true;
  isRefreshing = true;
  return new Promise((resolve, reject) => {
    options.handleTokenRefresh.call(options.handleTokenRefresh)
      .then((tokenData) => {
        options.setTokenData(tokenData, api);
        options.attachTokenToRequest(originalRequest, tokenData.token);
        processQueue(null, tokenData.token);
        resolve(api.request(originalRequest));
      })
      .catch((err) => {
        processQueue(err, null);
        reject(err);
      })
      .finally(() => {
        isRefreshing = false;
      });
  });
};

api.interceptors.response.use(undefined, interceptor);

export default api;
